import { TCarouselConfigProps } from './Carousel.types';

export const DEFAULT_CONFIG: TCarouselConfigProps = {
  interval: 5000,
  autoPlay: true,
  swipeable: true,
  infiniteLoop: true,
  showStatus: false,
  showArrows: false,
  showThumbs: false,
  transitionTime: 300,
  labels: { leftArrow: '', item: '', rightArrow: '' },
  emulateTouch: true,
};
